import Link from "next/link";
import {
  RiNftFill,
  RiNftLine,
  RiExchangeDollarFill,
} from "react-icons/ri";
import React from "react";
const NFTStatsCard = ({ collections, minted, sold }) => (
    <div className="dark:bg-jacarta-800 bg-white rounded-2xl p-5 shadow-sm hover:shadow-lg transition-all h-full relative overflow-hidden">
      {/* Coming Soon Overlay */}
      <div className="absolute inset-0 bg-jacarta-900/80 backdrop-blur-sm z-20 flex flex-col items-center justify-center">
        <div className="bg-accent/20 p-3 rounded-full mb-3">
          <RiNftFill className="text-accent text-3xl" />
        </div>
        <h4 className="text-white font-display text-lg mb-2">Coming Soon</h4>
        <p className="text-jacarta-300 text-sm text-center max-w-[200px]">
          NFT marketplace features will be available soon!
        </p>
    
      </div>
      
      <div className="flex items-center justify-between mb-2">
        <div className="flex items-center gap-2">
          <RiNftFill className="text-accent text-xl" />
          <h3 className="text-base font-display">NFT Statistics</h3>
        </div>
        <Link href="/dashboard/nfts" className="text-xs text-jacarta-800 dark:text-accent">
          View Collections →
        </Link>
      </div>
      
      <div className="mt-3 space-y-3 relative z-10">
        <div className="bg-jacarta-50 dark:bg-jacarta-700/50 rounded-xl p-4 backdrop-blur-sm">
          <p className="text-2xl font-bold text-jacarta-700 dark:text-white">
            {collections?.toLocaleString()}
          </p>
          <p className="text-sm text-jacarta-700 dark:text-jacarta-300">Total Collections</p>
        </div>
  
        <div className="grid grid-cols-2 gap-3">
          <div className="bg-jacarta-50 dark:bg-jacarta-700/50 p-3 rounded-xl backdrop-blur-sm">
            <div className="flex items-center gap-2 mb-1">
              <span className="text-xs px-2 py-1 bg-accent/10 text-accent rounded-lg">
                <RiNftLine className="inline-block" />
              </span>
              <p className="text-lg font-semibold dark:text-accent">{minted?.toLocaleString()}</p>
            </div>
            <p className="text-xs text-jacarta-700 dark:text-jacarta-300">NFTs Minted</p>
          </div>
          <div className="bg-jacarta-50 dark:bg-jacarta-700/50 p-3 rounded-xl backdrop-blur-sm">
            <div className="flex items-center gap-2 mb-1">
              <span className="text-xs px-2 py-1 bg-green-500/10 text-green-500 rounded-lg">
                <RiExchangeDollarFill className="inline-block" />
              </span>
              <p className="text-lg font-semibold dark:text-accent">{sold?.toLocaleString()}</p>
            </div>
            <p className="text-xs text-jacarta-700 dark:text-jacarta-300">NFTs Sold</p>
          </div>
        </div>
  
        <div className="mt-3 p-3 bg-jacarta-50 dark:bg-jacarta-700/50 rounded-xl backdrop-blur-sm">
          <div className="flex items-center justify-between">
            <span className="text-sm text-jacarta-700 dark:text-jacarta-300">Mint Success Rate</span>
            <span className="text-sm text-accent">85%</span>
          </div>
          <div className="w-full h-2 bg-jacarta-200 dark:bg-jacarta-600 rounded-full mt-2">
            <div className="h-full bg-accent rounded-full" style={{ width: '85%' }} />
          </div>
        </div>
      </div>
    </div>
  );
  export default NFTStatsCard